import { useNavigate } from "react-router-dom";
import { ChatApiRoutes } from "../../../../shared/api-routes/chat.api-routes";
import http from "../../../../shared/utils/http";
import "../ActionButton.scss";
import "./MsgButton.scss";

export interface MsgButtonProps {
	memberId: string;
	size?: "l" | "m";
	onMessageClick?: () => void;
}

export const MsgButton: React.FC<MsgButtonProps> = ({ memberId, size, onMessageClick }) => {
	const navigate = useNavigate();

	const sendMessage = () => {
		onMessageClick?.();
		http.get(ChatApiRoutes.DOES_CHAT_EXIST(memberId)).then((res) => {
			if (res) {
				navigate("/messages/" + res.id);
			} else {
				navigate("/messages/new/" + memberId);
			}
		});
	};

	return (
		<div
			onClick={sendMessage}
			className={`action-btn-${size} send-message`}
		>
			Message
		</div>
	);
};
